import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Tag } from '../Tag';
import { ARROW_RIGHT_KEY, ARROW_LEFT_KEY } from '../Utils/constant';
import styles from '@dtsl/css-tabs/dist/index.module.css';
function Tabs(props) {
  const {
    tabs,
    activeIndex,
    children,
    tabStyles,
    tabListStyles
  } = props;
  const [active, setActive] = useState(activeIndex);
  const [focused, setFocused] = useState(activeIndex);
  const ref = useRef(null);
  const onSelect = (event, tab, index) => {
    event.preventDefault();
    setActive(index);
    setFocused(index);
    props.onSelect(tab, index, event);
  };
  useEffect(() => {
    if (activeIndex !== active) {
      setActive(activeIndex);
    }
  }, [activeIndex]);
  const handleNextTab = (e, firstTabInRound, nextTab, lastTabInRound) => {
    const selectedTabIndex = focused === lastTabInRound ? firstTabInRound : nextTab;
    //setFocused(selectedTabIndex); //Uncomment this line if manual selection
    if (ref && ref.current) {
      var _ref$current$children, _ref$current$children2;
      (_ref$current$children = ref.current.children[selectedTabIndex]) === null || _ref$current$children === void 0 ? void 0 : _ref$current$children.children[0].focus();
      onSelect(e, (_ref$current$children2 = ref.current.children[selectedTabIndex]) === null || _ref$current$children2 === void 0 ? void 0 : _ref$current$children2.children[0], selectedTabIndex); //Comment this line if manual selection
    }
  };

  const handleKeyPress = event => {
    const tabCount = Object.keys(tabs).length - 1;
    if (event.key === ARROW_LEFT_KEY) {
      const last = tabCount;
      const next = parseInt(focused) - 1;
      handleNextTab(event, last, next, 0);
    }
    if (event.key === ARROW_RIGHT_KEY) {
      const first = 0;
      const next = parseInt(focused) + 1;
      handleNextTab(event, first, next, tabCount);
    }

    //Code for manual selection in key navigation (Enter and Space)
    // if (event.key === ENTER_KEY || event.keyCode === ENTER_KEYCODE) {
    //   setActive(focused);
    //   onSelect(event, ref.current?.children[focused]?.children[0], focused);
    // }
  };

  const tabsHTML = /*#__PURE__*/React.createElement("ul", {
    ref: ref,
    className: styles['sib-tabs'],
    role: "tablist",
    onKeyDown: handleKeyPress,
    style: {
      ...tabListStyles
    }
  }, tabs.map((tab, index) => {
    const {
      url = '#',
      target = '_self',
      label,
      tagValue,
      svg,
      id
    } = tab;
    return /*#__PURE__*/React.createElement("li", {
      className: styles['sib-tab'],
      key: index + label,
      role: "presentation",
      style: {
        ...tabStyles
      }
    }, /*#__PURE__*/React.createElement("a", {
      id: id ? id : `tab-${index}`,
      role: "tab",
      tabIndex: active === index ? 0 : -1,
      "aria-controls": `tabpanel-${id ? id : `tab-${index}`}`,
      "aria-selected": active === index,
      href: url,
      rel: "noreferrer",
      className: `${styles['sib-tab--link']} ${active === index ? styles['active'] : ''} ${focused === index ? styles['is-focused'] : ''}`,
      onClick: event => onSelect(event, tab, index),
      target: target
    }, /*#__PURE__*/React.createElement("span", {
      className: styles['sib-tab-label']
    }, svg && /*#__PURE__*/React.cloneElement(svg, {
      className: styles['sib-tab__icon']
    }), label, tagValue ? /*#__PURE__*/React.createElement(Tag, {
      label: tagValue,
      border: true,
      className: styles['sib-tab--tags']
    }) : '')));
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, tabsHTML, children);
}
Tabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    target: PropTypes.string,
    label: PropTypes.string,
    tagValue: PropTypes.string,
    svg: PropTypes.node
  })),
  children: PropTypes.node.isRequired,
  activeIndex: PropTypes.number,
  onSelect: PropTypes.func,
  tabStyles: PropTypes.object,
  tabListStyles: PropTypes.object
};
Tabs.defaultProps = {
  activeIndex: 0,
  tabs: [],
  onSelect: () => {},
  tabStyles: {},
  tabListStyles: {}
};
export default Tabs;